import { useTheme } from "@mui/material";
import { getClientTheme } from "../clientConfig";

const clientTheme = getClientTheme();

interface LogoProps {
  maxWidth?: string;
  maxHeight?: string;
}

export const Logo = ({
  maxWidth = clientTheme.logoMaxWidth ?? "130px",
  maxHeight = clientTheme.logoMaxHeight ?? "40px",
}: LogoProps) => {
  const theme = useTheme();
  const logo =
    theme.palette.mode === "dark"
      ? clientTheme.logos.dark
      : clientTheme.logos.light;

  return (
    <img
      src={logo}
      alt={`${clientTheme.title} Logo`}
      style={{
        width: "100%",
        height: "auto",
        maxWidth,
        maxHeight,
      }}
    />
  );
};
